import { Box, Button, Grid, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';
import useToggle from '../../hooks/useToggle';
import LaunchDarklyContext from '../../shared-components/contexts/LaunchDarklyContext';
import FeatureFeedbackService from '../../shared-services/Feedback/FeatureFeedbackService';
import Notations from './Components/Notations/Notations';
import OptOutModal from './Components/OptOutModal';
import PageControls from './Components/PageControls';
import Students from './Components/Students/Students';

const Home = () => {
  //@ts-ignore
  const appCues = window.Appcues;
  const launchDarkly = useContext(LaunchDarklyContext);
  const navigate = useNavigate();

  const [showInNetworkOnly, setShowInNetworkOnly] = React.useState<
    boolean | undefined
  >(undefined);
  const [showOptOutModal, toggleShowOptOutModal] = useToggle(false);
  const optBackIn = new URLSearchParams(useLocation().search).get('optin');

  useEffect(() => {
    if (appCues) {
      appCues.on('flow_started', (event: any) => {
        if (event.flowId === 'f3c3406c-0c29-4353-8ec8-100697e9eff6') {
          FeatureFeedbackService.createFeatureFeedback({
            feature: 'BeaconHome',
            rating: '',
            text: '[Auto Created] Institutional Opt In',
            usedToOptIn: true,
            usedToOptOut: false,
            canBeContacted: false,
          });
        }
      });
    }
  }, [appCues]);

  if (optBackIn === 'true') {
    FeatureFeedbackService.createFeatureFeedback({
      feature: 'BeaconHome',
      rating: '',
      text: '[Auto Created] Opt In Via Student Page',
      usedToOptIn: true,
      usedToOptOut: false,
      canBeContacted: false,
    });
    navigate('/', { replace: true });
  }

  return (
    <>
      <Box display="flex">
        <Box sx={{ flexGrow: 1 }}>
          <Box>
            <Typography variant="h1">Home</Typography>
          </Box>
        </Box>
        <Box
          display="flex"
          justifyContent="flex-end"
          style={{ marginTop: '12px' }}
        >
          <PageControls
            showInNetworkOnly={showInNetworkOnly}
            setShowInNetworkOnly={setShowInNetworkOnly}
          />
        </Box>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} sm={12} md={6} lg={7}>
          <Notations showInNetworkOnly={showInNetworkOnly} />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={5}>
          <Students showInNetworkOnly={showInNetworkOnly} />
        </Grid>
      </Grid>

      {launchDarkly['home-can-opt-out'] && (
        <Box display="flex">
          <Box sx={{ flexGrow: 1 }}></Box>
          <Box>
            <Button
              variant="text"
              onClick={() => toggleShowOptOutModal()}
              style={{ color: '#0066cc', textTransform: 'none' }}
            >
              Opt out of Beacon Home and return to Students
            </Button>
          </Box>
        </Box>
      )}
      <OptOutModal open={showOptOutModal} close={toggleShowOptOutModal} />
    </>
  );
};

export default Home;
